import { toast } from 'react-toastify';
import { get } from '../../services/apiController';

export const GetSingleVendor = async (vendorId) => {
  try {
    const response = await get(`/vendor-masters/${vendorId}`);
    return response.data;
  } catch (err) {
    console.log('err', err);
    toast.error(err.message);
    throw err;
  }
};
